const welcomeMarkdown = `Model Aeon Trespass: Odyssey attacks, compare loadouts, and see how Kratos growth changes wound chance over time.

Bundled card data is sourced from [ATCC](https://aedanthornton.github.io/ATCC) (courtesy of Artifus).

---

### Quick Start

1. Open **Simulator → Spoiler Settings** and reveal the cycles you want to work with.
2. Choose **Armory Loadout Simulator** to build from saved armory items, or **Manual Loadout Simulator** to enter raw stats directly.
3. Choose **Attack Simulator** for a single target check, or **Loadout Analyzer** to compare loadouts across BP cards and token growth.
4. Review the target, Kratos pool, and loadouts, then run the simulator.

---

### Simulation Modes

**Armory Loadout Simulator**  
Build from Titans, Kratos Tables, Weapons, Gear, and Mnemos stored in your armory. This is the fastest path for testing real game setups.

**Manual Loadout Simulator**  
Enter attack dice, power dice, re-rolls, auto-hits, and per-hit overrides directly. Best for quick experiments, validation, and odd edge cases.

**Attack Simulator**  
Runs a set of loadouts against the current primordial using the current Kratos pool and shows the likelihood of wounding for each loadout.

**Loadout Analyzer**  
Charts how selected Kratos tokens change wound chance across a primordial's BP I, BP II, and BP III targets so weapons/loadouts are easier to compare side by side.

---

### Armory and Data

- The app ships with bundled ATCC-derived data for Titans, Kratos Tables, Weapons, and Gear.
- Use **Armory Library** for custom items, manual fixes, and personal tags.
- Use **Armory Library → Data Storage** to download, upload, or reset your local data.
- The ATCC snapshot is captured at build time, so live site changes do not unexpectedly change simulator behavior.

---

### Power Re-rolls

Power re-rolls are checked after the initial power roll total is calculated.

- If the roll already meets or beats the current **A.T.**, no power re-roll is spent.
- If the roll is below **A.T.**, the simulator checks whether power re-rolls are available and allowed by your settings.
- **Table Heuristic** is the recommended default. It chooses simultaneous power re-rolls the way a strong player usually would: protect value when close, take more risk when clearly behind.
- **Legacy Heuristic** and **Optimal Strategy** remain available for comparison and validation, but \`Table Heuristic\` is the main gameplay-facing model.

That means the current target **A.T.** matters twice: it decides whether a wound happens, and it also decides whether power re-rolls are spent at all.

---

### Tips

- Hover the **ⓘ** icons throughout the app for item details and translated loadout data.
- **Advanced** mode unlocks deeper editing fields and override controls.
- Use custom tags for your own organization; ATCC metadata tags are handled automatically.

---

### Limitations

Most core attack mechanics are supported, but some one-off card abilities still need manual review.

Board-state effects, positioning rules, and similar context-dependent abilities are not modeled directly.

For questions, bug reports, suggestions, or strange edge cases, use the fan-run [The Unknown Discord's AT:O Rules -> Attack Simulator / Calculator thread](https://discord.com/channels/613726628559847445/1297857078089748552).
`;

export default welcomeMarkdown;
